<template>
  <div id="custom_table" class="main-tab">
    <ul class="list">
      <li>
        <span>上级</span>
        <span>{{baseInfoData.parentId ? baseInfoData.parentId : ''}}</span>
        <span>{{baseInfoData.parentWechatName}}</span>
      </li>
      <li>
        <span>二级分销商</span>
        <span>{{baseInfoData.distributorSecondCount ? baseInfoData.distributorSecondCount : '--'}}<i v-if="baseInfoData.distributorSecondCount">人</i></span>
        <span></span>
      </li>
      <li>
        <span>会员</span>
        <span>{{baseInfoData.memberCount ? baseInfoData.memberCount : '--'}}<i v-if="baseInfoData.memberCount">人</i></span>
        <span v-if="baseInfoData.memberCount > 0" @click="gotoHisMember" class="gotoHisMember">查看</span>
        <span v-else></span>
      </li>
    </ul>
    <!-- <el-table
      :data="tableData"
      border
      style="width:100%"
      height="100%"
      highlight-current-row>
      <el-table-column
        v-for="(column, index) in tableColumns"
        :fixed="column.fixed"
        :align="column.sortable ? 'right' : 'center'"
        :prop="column.name"
        :key="index"
        :label="column.title">
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
export default {
  name: 'comTable',
  components: {},
  directives: {

  },
  props: ['baseInfoData'],
  data() {
    return {
      tableColumns: this.columnName
    }
  },
  created() {

  },
  computed: {

  },
  mounted() {

  },
  methods: {
    gotoHisMember() {
      this.$parent.$parent.$parent.swicthTab({ 'name': '6' })
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
$borderColor: #dcdfe6;
.main-tab{
  // width:60%;
  .list {
    width: 845px;
    border-radius: 4px;
    border: 1px solid $borderColor;
    border-bottom: none;
    li {
      list-style: none;
      height: 46px;
      border-bottom: 1px solid $borderColor;
      span {
        color: #111;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        width: 30%;
        font-size: 14px;
        line-height: 46px;
        height: 46px;
        border-right: 1px solid $borderColor;
      }
      span:last-child {
        border-right: none;
        width: 38%;
      }
      .gotoHisMember {
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/_app/outlet/src/views/distributorBaseInfo/comTable/index.vue